var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{ref:"header",class:{hide: _vm.hide}},[_c('img',{attrs:{"id":"logo","alt":"Illiade logo","src":require("../assets/logo/logo.png")},on:{"click":_vm.goUp}})])}
var staticRenderFns = []

export { render, staticRenderFns }